import { BackendResponse } from "../BackendResponse";
import { FormDataWithKeyCheck } from "../FormDataFactory";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { Answers } from "../questionForm/QuestionFormTypes";

export interface ApplyWithoutProfileResponse extends BackendResponse {
  idCandidate: number | null;
  idVacancyCandidate: number | null;
  idRecruitmentCandidate: number | null;
  foundExistingCandidate: boolean;
  foundExistingCaseCandidate: boolean;
}

export interface ApplyWithoutProfileParameters extends NextApiParams {
  formData: FormDataWithKeyCheck<NoLoginApplyParametersMultiAttachments>;
}

export const applyWithoutProfileMultiAttachments = withNextApi<
  ApplyWithoutProfileResponse,
  ApplyWithoutProfileParameters
>("/cvp/CvpApplyWithoutProfileMultiAttachments");

export interface NoLoginApplyParametersMultiAttachments {
  attachments: any[];
  firstName: string;
  lastName: string;
  mobile: string;
  email: string;
  dob: string;
  availableFrom: string;
  zipCode: string;
  address: string;
  city: string;
  country: string;
  acceptedGeneralConsent: boolean;
  idLanguage: number | null;
  typeNationality: number | null;
  typeGender: number | null;
  typeRelation: number;
  idRelation: number;
  applicationText: string;
  cvpExtraFieldValues: { [key: string]: string };
  cvpExtraApplicationFieldValues: { [key: string]: string };
  questionFormAnswers: Answers[];
}
